<template>
  <div>
    <h5>{{ `${number}. ${question.title}` }}</h5>
    <div v-html="question.content"></div>
    <Img v-for="(image, key) in question.images" :key="key" :url="image.url" :data="image.data" />

    <ul>
      <li v-for="(option, key) in question.options" :key="key">
        <Option :number="key + 1" :option="option" />
      </li>
    </ul>
  </div>
</template>

<script>
  import Option from './Option'
  import Img from './Img'

  export default {
    data () {
      return {}
    },

    props: [ 'number', 'question' ],

    components: {
      Option,
      Img
    }
  }
</script>
